import React, { useState } from 'react';

import {
  View,
  Text,
  ScrollView,
  Image,
  FormField,
  LargeButton,
  TouchableOpacity,
} from '../../app-components';

import { validateEmail } from '../../Lib/helpers';
import { TextInput } from '../../app-components/input-components/Editors';
import { Form } from '../../app-components/form/Form';

import { appraiseLogo, notificationError } from '../../images';
import loginStyle from './loginStyle';
import { isMobile } from '../../app-components/UtilityFunctions';
import { h10_Montessart } from '../../theme/fonts';

export default ({ posShopForgotPassword, images }) => {
  const { loginText, leftSide } = loginStyle;
  return ({ navigation }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const handleSubmit = ({ data }) => {
      posShopForgotPassword(data).then((res) => {
        if (res === 'Rest Password link has been sent successfully') {
          navigation.replace('login');
        }
      });
    };
    return (
      <ScrollView>
        <View
          style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>
          {/* left side started */}
          <View style={leftSide}>
            <Image source={appraiseLogo} style={{ width: '170px' }} />
            <Text
              style={{
                fontFamily: 'Poppins',
                fontStyle: 'italic',
                fontSize: '18px',
                color: '#fafafa',
              }}>
              Lorem ipsum dolor sit
            </Text>
            <View style={{ display: 'flex', gap: '30px' }}>
              <Text
                style={{
                  fontFamily: 'Montserrat',
                  fontSize: '36px',
                  color: '#FAFAFA',
                }}>
                Welcome Back!
              </Text>
              <View
                style={{ border: '1px solid #FAFAFA', width: '68.5px' }}></View>
              <Text
                style={{
                  fontFamily: 'Poppins',
                  fontSize: '18px',
                  color: '#FAFAFA',
                  lineHeight: '27px',
                }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna
              </Text>
            </View>
          </View>
          {/* left side over */}
          {/* right side started */}
          <View
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              width: '65%',
              flexDirection: !isMobile ? 'row' : 'column',
            }}>
            <View>
              <View
                style={{
                  alignItems: 'center',
                }}>
                <Text style={{ ...loginText }}>Forgot Password</Text>

                <Text
                  style={{
                    width: !isMobile && 450,
                    height: 50,
                    fontFamily: 'Nunito',
                    fontSize: 16,
                    color: '#0e0d25',
                    marginTop: !isMobile ? 22 : 15,
                    marginBottom: 20,
                  }}>
                  Please enter your registered email address. We’ll send
                  instructions to help reset your password.
                </Text>
              </View>
              <ScrollView
                style={{
                  overflow: 'hidden',
                  flex: 1,
                  alignItems: !isMobile && 'center',
                }}>
                <Form
                  scrollable={false}
                  mandatory={{
                    email: 'Email is mandatory',
                  }}
                  required={{
                    email: 1,
                  }}
                  onSubmit={handleSubmit}
                  containerStyle={{ flex: 1 }}
                  bodyContainerStyle={{
                    margin: 0,
                    flex: 1,
                  }}
                  validations={{
                    email: ({ data }) => validateEmail(data.email),
                  }}>
                  <ForgotPasswordNew
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    images={images}
                    navigation1={navigation}
                  />
                </Form>
              </ScrollView>
            </View>
          </View>
        </View>
      </ScrollView>
    );
  };
};

const ForgotPasswordNew = ({
  form_context: formContext,
  errorMessage,
  images,
  navigation1,
}) => {
  const { handleSubmit } = formContext;
  const { loginBoxStyle, errorStyle } = loginStyle;

  return (
    <View style={{ ...loginBoxStyle, width: !isMobile && 450 }}>
      <View>
        <FormField
          field="email"
          variant="filled"
          floatingLabelStyle={{
            ...h10_Montessart,
          }}
          activeLabelStyle={{
            ...h10_Montessart,
          }}
          label={'forgotPassword.labels.email'.getLabel()}>
          <TextInput />
        </FormField>
      </View>
      <View
        style={{
          marginTop: 48,
          marginBottom: 20,
          alignItems: 'center',
        }}>
        <LargeButton
          color="#444444"
          width="120px"
          hoverColor={null}
          label={'forgotPassword.buttons.sendEmail'.getLabel()}
          labelStyle={{
            fontSize: 16,
            color: '#fAfAfA',
            fontFamily: 'Montessart',
          }}
          onClick={handleSubmit}
          height={48}
          borderRadius={28}
        />
      </View>
      <View
        style={{
          marginTop: 15,
          marginBottom: 20,
          alignItems: 'center',
        }}>
        <TouchableOpacity
          style={{ cursor: 'pointer' }}
          onPress={() => navigation1.reset('login')}>
          <Text
            style={{
              color: '#605BFF',
              fontFamily: 'Nunito',
              fontWeight: '400',
              fontSize: '16px',
            }}>
            {'forgotPassword.buttons.backToLogin'.getLabel()}
          </Text>
        </TouchableOpacity>
      </View>
      {errorMessage ? (
        <View
          style={{
            flexDirection: 'row',
            marginTop: 27,
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Image source={notificationError} style={{ height: 18, width: 18 }} />
          <Text style={{ ...errorStyle }}>{errorMessage}</Text>
        </View>
      ) : null}
    </View>
  );
};
